import axios from "axios";
import { CLOUDINARY_PRESET } from "./cloudinaryConstants";

export function uploadToCloudinary(file, publicId) {
  return axios.post("https://api.cloudinary.com/v1_1/gonation/image/upload", {
    file,
    upload_preset: CLOUDINARY_PRESET,
    public_id: publicId
  });
}

export function createImageObj(img) {
  console.log(img);
  if (img) {
    return {
      id: img.data.public_id,
      dominantColor: img.data.colors[0][0],
      defaultHeight: img.data.height
    };
  }
  return null;
}



// WEBPACK FOOTER //
// ./src/helpers/cloudinaryUpload.js